import {
    useMemo,
} from 'react'
import {
    useLocation,
} from 'react-router-dom'
import {
    SkyNetTableTabWithLabel,
} from '../types/skyNetTable.types'

export default function useTableTab({
    tabs,
}: {tabs: SkyNetTableTabWithLabel[]}) {
    const {
        pathname,
    } = useLocation()

    return useMemo(() => {
        const selected = tabs.find(({
            url: tabUrl,
        }) => {
            return pathname.match(new RegExp(`/${tabUrl}`, 'g'))
        })

        return selected || tabs[0]
    }, [
        pathname,
        tabs,
    ])
}
